import merge from 'lodash/merge'
import es from '../es'
import tableroSeleccion from './tablero-seleccion.json'
import forgotPassword from './forgot-password.json'
import talentPool from './talent-pool.json'
import currencyMask from './currency-mask.json'
import dashboard from './dashboard.json'
import adminUser from './admin-user.json'
import homePage from './home-page.json'
import userProfile from './user-profile.json'
import companyProfile from './company-profile.json'
import changePassword from './change-password.json'
import statistics from './statistics.json'
import productos from './productos.json'
import signUp from './sign-up.json'
import signIn from './sign-in.json'
import avisoPublicacion from './aviso-publicacion.json'
import avisoPublicacionProductos from './aviso-publicacion-productos.json'
import avisoProductos from './aviso-productos.json'
import errorPages from './error-pages.json'
import resumenCuenta from './resumen-cuenta.json'
import avisos from './avisos.json'
import ecommerce from './ecommerce.json'

const ar = {
  ...es,
  tableroSeleccion: merge({}, es.tableroSeleccion, tableroSeleccion),
  forgotPassword: merge({}, es.forgotPassword, forgotPassword),
  talentPool: merge({}, es.talentPool, talentPool),
  currencyMask,
  dashboard: merge({}, es.dashboard, dashboard),
  adminUser: merge({}, es.adminUser, adminUser),
  homePage: merge({}, es.homePage, homePage),
  userProfile: merge({}, es.userProfile, userProfile),
  companyProfile: merge({}, es.companyProfile, companyProfile),
  changePassword: merge({}, es.changePassword, changePassword),
  statistics: merge({}, es.statistics, statistics),
  signUp: merge({}, es.signUp, signUp),
  signIn: merge({}, es.signIn, signIn),
  avisoPublicacion: merge({}, es.avisoPublicacion, avisoPublicacion),
  avisoPublicacionProductos: merge({}, es.avisoPublicacionProductos, avisoPublicacionProductos),
  avisoProductos: merge({}, es.avisoProductos, avisoProductos),
  productos: merge({}, es.productos, productos),
  errorPages: merge({}, es.errorPages, errorPages),
  resumenCuenta: merge({}, es.resumenCuenta, resumenCuenta),
  avisos: merge({}, es.avisos, avisos),
  ecommerce: merge({}, es.ecommerce, ecommerce),
}

export default ar
